import type { Book } from "@book-club/shared";
import { useQuery } from "@tanstack/react-query";
import booksService from "@/features/books/services/booksService";
import DURATIONS from "@/shared/constants/durations";
import { booksKeys } from "./booksQueryKeys";

export function useVisibleBooks() {
    return useQuery<Book[], Error>({
        gcTime: DURATIONS.ONE_DAY,
        queryFn: () => booksService.getVisibleBooks(),
        queryKey: booksKeys.visible(),
        staleTime: DURATIONS.ONE_DAY,
    });
}
